import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { ApolloProvider } from 'react-apollo'

import * as moment from 'moment'
import 'moment/locale/cs'

import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import './index.css'
import store from './store'
import history from './history'
import ApolloClient from './apollo'

moment.locale('cs')

const app = (
  <Provider {...{ store }}>
    <ApolloProvider client={ApolloClient}>
      <Router {...{ history }}>
        <App />
      </Router>
    </ApolloProvider>
  </Provider>
)

ReactDOM.render(app, document.getElementById('root') as HTMLElement)
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx